import React from "react";
import { Link } from "react-router-dom";

const linkColumns = [
  {
    title: "Producto",
    links: [
      { label: "Buscar licitaciones", to: "/licitaciones" },
      { label: "Catálogo de proveedores", to: "/catalogo" },
      { label: "Registrar empresa", to: "/company-register" },
      { label: "Precios", to: "/precios" },
      { label: "Cómo funciona", to: "/como-funciona" },
    ],
  },
  {
    title: "Cuenta",
    links: [
      { label: "Ingresar", to: "/login" },
      { label: "Crear cuenta", to: "/register" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Condiciones de uso", to: "/condiciones-uso" },
      { label: "Aviso de privacidad", to: "/aviso-privacidad" },
    ],
  },
];

const CONTACT_EMAIL = "procuperu1@gmail.com";
const CONTACT_PHONE = "939 560 222";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-1">
            <img
              src={`${process.env.PUBLIC_URL}/fotos/logofin2.png`}
              alt="Procu"
              className="h-14 w-auto"
            />
            <p className="mt-3 text-sm text-muted-foreground">
              Conectamos empresas y proveedores en Perú.
            </p>
            <ul className="mt-3 space-y-1">
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+51${CONTACT_PHONE.replace(/\s/g, "")}`}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  {CONTACT_PHONE}
                </a>
              </li>
            </ul>
          </div>
          {linkColumns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-semibold text-foreground">{column.title}</h3>
              <ul className="mt-3 space-y-2">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-muted-foreground hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 border-t border-border pt-6">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Procu. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
